import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M113.08 41.87C113.08 41.87 85.4503 27.42 84.0503 25.66C82.6503 23.9 81.7103 1 81.7103 1H59.7003C59.7003 1 58.7603 23.9 57.3603 25.66C55.9603 27.42 28.3203 41.87 28.3203 41.87C28.3203 41.87 40.5703 56.92 70.7003 56.92C100.83 56.92 113.08 41.87 113.08 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M126.8 47.5599C123.72 43.9299 89.1601 26.7499 89.1601 26.7499L84.0301 17.1699L70.7001 24.7099L57.3701 17.1699L52.2401 26.7499C52.2401 26.7499 17.6801 43.9199 14.6001 47.5599C11.5201 51.1899 7.08008 72.3299 7.08008 72.3299H134.31C134.31 72.3299 129.87 51.1999 126.8 47.5599Z"
        fill="white"
        stroke="#D3D3D3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M89.15 26.7599L78.22 38.3199L70.64 25.1099L63.18 38.3199L52.25 26.7599"
        fill="white"
        stroke="#D3D3D3"
        strokeMiterlimit="10"
      />
      <path
        d="M71.5004 41.94L75.1404 34.0099L70.7604 25.97L66.2604 34.0099L69.9004 41.94L64.4404 71.36H76.9704L71.5004 41.94Z"
        fill={secondaryFill}
      />
      <path
        d="M51.77 25.6599L70.39 72.6699H2C2 72.6699 8.61 47.3099 9.93 45.5599C11.25 43.8099 51.77 25.6599 51.77 25.6599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M46.2602 28.0598L45.1602 50.5798L52.4302 53.2098L48.6802 60.6398L59.9102 72.8898"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M89.6395 25.6599L71.0195 72.6699H139.4C139.4 72.6699 132.79 47.3099 131.47 45.5599C130.15 43.7999 89.6395 25.6599 89.6395 25.6599Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M95.1402 28.0598L96.2402 50.5798L88.9802 53.2098L92.7202 60.6398L81.4902 72.8898"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="70.7012"
          y1="28.6268"
          x2="70.7012"
          y2="11.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
